import React from 'react';
import type IconInterface from '../interfaces/Icon';

export default function EncuestasIcon({ color = '#F8F8F8' }: IconInterface): JSX.Element {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15C2.6 3 2 3.6 2 4.3v15.4C2 20.4 2.6 21 3.5 21h15c.9 0 1.5-.6 1.5-1.3V4.3C20 3.6 19.4 3 18.5 3z'
        fill={color}
      />
    </svg>
  );
}
